module.exports = __webpack_public_path__ + "static/media/need-doctor-on-demand.d1cc7626.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/need/need-doctor-on-demand.jpg
// module id = 372
// module chunks = 0